<template>
  <div v-if="groupedDescriptors">
    <h3>Results:</h3>
    <table :style="tableStyle">
      <thead>
        <tr>
          <th :style="headerStyle">Code</th>
          <th :style="headerStyle">Strand</th>
          <th :style="headerStyle">Sub-strand</th>
          <th :style="headerStyle">Descriptor</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loop through each group (by level and area) -->
        <template
          v-for="(descriptors, groupKey) in groupedDescriptors"
          :key="groupKey"
        >
          <!-- Group Header -->
          <tr>
            <td :style="groupHeaderStyle" colspan="4">{{ groupKey }}</td>
          </tr>
          <!-- Loop through each descriptor within the group -->
          <tr
            v-for="(descriptor, index) in descriptors"
            :key="descriptor.code"
            :style="getRowStyle(index)"
          >
            <td :style="cellStyle">
              <a :href="descriptor.url" target="_blank">{{
                descriptor.code
              }}</a>
            </td>
            <td :style="cellStyle">{{ descriptor.strand }}</td>
            <td :style="cellStyle">{{ descriptor.sub_strand }}</td>
            <td :style="cellStyle" :title="descriptor.summary">
              {{ descriptor.summary }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
  <div v-else>
    <p>No descriptors matched. Please try again with different descriptors.</p>
  </div>
</template>

<script>
export default {
  props: ["groupedDescriptors"],
  data() {
    return {
      tableStyle: {
        width: "100%",
        "border-collapse": "collapse",
        "font-family": "Verdana, sans-serif",
        "font-size": "8pt",
      },
      headerStyle: {
        padding: "8px",
        border: "1px solid #333",
        "text-align": "left",
        "font-family": "Verdana, sans-serif",
        "font-size": "8pt",
      },
      cellStyle: {
        padding: "8px",
        border: "1px solid #333",
        "text-align": "left",
        "font-family": "Verdana, sans-serif",
        "font-size": "8pt",
      },
      groupHeaderStyle: {
        "background-color": "#bad0ee",
        "font-weight": "bold",
        "text-align": "left",
        padding: "8px",
        border: "1px solid #333",
        "font-family": "Verdana, sans-serif",
        "font-size": "8pt",
      },
    };
  },
  methods: {
    getRowStyle(index) {
      return {
        ...this.cellStyle,
        "background-color": index % 2 === 0 ? "#f0f8ff" : "#ffffff",
      };
    },
  },
};
</script>
